export default __webpack_public_path__ + "static/media/ISMO CLASS-3 EXAM PATTERN 2026-27.5138b59d.pdf";